export default __webpack_public_path__ + "static/media/search-icon.cd820f5a.svg";